export const SERVICES = [
  {
    id: "covering",
    index: "01",
    image:
      "https://images.pexels.com/photos/10126663/pexels-photo-10126663.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    id: "ppf",
    index: "02",
    image:
      "https://images.pexels.com/photos/10126661/pexels-photo-10126661.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "lg:row-span-2",
  },
  {
    id: "dechromage",
    index: "03",
    image:
      "https://images.unsplash.com/photo-1712214910040-1f7f5925b16a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxzcG9ydHMlMjBjYXIlMjBkYXJrJTIwc3R1ZGlvfGVufDB8fHx8MTc4NDU2MzQyMXww&ixlib=rb-4.1.0&q=85",
    span: "",
  },
  {
    id: "flotte",
    index: "04",
    image:
      "https://images.pexels.com/photos/18320398/pexels-photo-18320398.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "",
  },
];

export const GALLERY = [
  {
    id: 1,
    before:
      "https://images.pexels.com/photos/10126661/pexels-photo-10126661.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    after:
      "https://images.unsplash.com/photo-1580654712603-eb43273aff33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxuZW9uJTIwYmx1ZSUyMHNwb3J0cyUyMGNhcnxlbnwwfHx8fDE3ODQ2MzkwOTl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: 2,
    before:
      "https://images.pexels.com/photos/18320398/pexels-photo-18320398.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    after:
      "https://images.unsplash.com/photo-1712214910040-1f7f5925b16a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxzcG9ydHMlMjBjYXIlMjBkYXJrJTIwc3R1ZGlvfGVufDB8fHx8MTc4NDU2MzQyMXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: 3,
    before:
      "https://images.pexels.com/photos/10126663/pexels-photo-10126663.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    after:
      "https://images.pexels.com/photos/28794445/pexels-photo-28794445.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  },
];

export const WHY_INDEXES = ["01", "02", "03"];

export const HEADLIGHT_FILMS = [
  { id: "jaune", accent: "#F5C518", image: "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/s79o5uig_IMG_4976.jpeg" },
  { id: "bleu", accent: "#3B82F6", image: "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/t7zlavmv_IMG_4977.webp" },
  { id: "transparent", accent: "#CBD5E1", image: "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/ks2cy1l0_IMG_4978.webp" },
  { id: "noir", accent: "#4B5563", image: "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/pfoqg4su_IMG_4979.webp" },
];

export const WRAP_COLORS = [
  { id: "bleu", swatch: "#1E40FF", image: "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/46hesw53_IMG_4988.webp" },
  { id: "rouge", swatch: "#6E1420", image: "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/ngpphhch_IMG_4984.webp" },
  { id: "noir", swatch: "#0A0A0A", image: "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/jvr4pj0q_IMG_4987.webp" },
  { id: "gris", swatch: "#6E6E6E", image: "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/qx5r3mdv_IMG_4983.webp" },
  { id: "blanc", swatch: "#EFEFEA", image: "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/a1eg7qku_IMG_4982.webp" },
];

export const DECHROMAGE = [
  { id: "vitres", image: "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/y1xx7975_IMG_4989.jpeg" },
  { id: "bandes", image: "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/h4qv0s57_IMG_4990.jpeg" },
];

export const TINT_LEVELS = ["70%", "50%", "42%", "35%", "20%", "15%", "5%", "3%"];
export const TINT_IMAGES = {
  chart: "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/m1cqk2sz_IMG_4993.jpeg",
  result: "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/0jep9fyj_IMG_4994.jpeg",
  vlt: "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/lfutacdp_IMG_4995.jpeg",
};

export const PPF = [
  { id: "transparent", image: "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/tybow05p_IMG_4985.webp" },
  { id: "noir", image: "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/6qboxwyl_IMG_4986.webp" },
];

export const POLISH_IMAGE = "https://customer-assets-jt897jd0.emergentagent.net/job_car-wrap-pro-3/artifacts/j4219hdn_IMG_4992.jpeg";

// Payment packages. Amounts are display-only; backend validates lookup_key + amount from Stripe.
export const PACKAGES = [
  { id: "reservation", price: 50, depositOnly: true, full: "acompte_reservation", deposit: "acompte_reservation" },
  { id: "lavage", price: 80, full: "lavage_full", deposit: "lavage_deposit" },
  { id: "toit", price: 150, full: "toit_full", deposit: "toit_deposit" },
  { id: "feux", price: 120, full: "feux_full", deposit: "feux_deposit" },
  { id: "dechromage_citadine", price: 200, full: "dechromage_citadine_full", deposit: "dechromage_citadine_deposit" },
  { id: "dechromage_berline", price: 280, full: "dechromage_berline_full", deposit: "dechromage_berline_deposit" },
];
